import React from 'react';
import { Heart, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-white to-yellow-50 pt-16 pb-8 px-4 border-t border-yellow-100">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="h-10 w-10 bg-gradient-to-r from-yellow-400 to-pink-400 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">J</span>
              </div>
              <span className="text-3xl font-bold bg-gradient-to-r from-yellow-500 to-pink-500 bg-clip-text text-transparent">
                Jashn
              </span>
            </div>
            <p className="text-gray-600">
              Creating unforgettable celebrations and magical moments since 2015. Your happiness is our celebration.
            </p>
            <div className="flex space-x-4">
              {[Facebook, Instagram, Twitter].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="h-10 w-10 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600 hover:bg-yellow-200 hover:text-yellow-700 transition-all duration-300 hover:scale-110"
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gray-800">Quick Links</h3>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Services', 'Reviews', 'Gallery', 'Contact'].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-yellow-600 hover:pl-2 transition-all duration-300 flex items-center"
                  >
                    <span className="h-1 w-1 bg-yellow-400 rounded-full mr-3 opacity-0 hover:opacity-100 transition-opacity"></span>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gray-800">Our Services</h3>
            <ul className="space-y-3">
              {['Wedding Planning', 'Birthday Parties', 'Corporate Events', 'Trip Planning', 'Venue Booking', 'Decoration'].map((service) => (
                <li key={service}>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-yellow-600 hover:pl-2 transition-all duration-300 flex items-center"
                  >
                    <span className="h-1 w-1 bg-pink-400 rounded-full mr-3 opacity-0 hover:opacity-100 transition-opacity"></span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gray-800">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-yellow-500 mt-1" />
                <div>
                  <p className="font-semibold">Call Us</p>
                  <p className="text-gray-600">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-yellow-500 mt-1" />
                <div>
                  <p className="font-semibold">Email</p>
                  <p className="text-gray-600">hassaanmansur@jashn.com</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-yellow-500 mt-1" />
                <div>
                  <p className="font-semibold">Visit Us</p>
                  <p className="text-gray-600">Fast Nuces, Islamabad</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter */}
        <div className="mb-12 p-8 bg-gradient-to-r from-yellow-50 to-pink-50 rounded-2xl border border-yellow-200">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4 text-gray-800">Stay Updated</h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
              Subscribe to get special offers, event ideas, and planning tips
            </p>
            <div className="flex max-w-md mx-auto gap-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-3 rounded-full border border-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
              />
              <button className="px-8 py-3 bg-gradient-to-r from-yellow-400 to-pink-400 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-yellow-200 transition-all duration-300">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-yellow-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 mb-4 md:mb-0">
              © {currentYear} Jashn Event Planners. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
          <div className="text-center mt-8">
            <p className="text-gray-500 text-sm flex items-center justify-center">
              Made with <Heart className="h-4 w-4 mx-1 text-pink-500 fill-pink-500" /> for celebrations worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;